import { render } from "./OnboardingPage.vue?vue&type=template&id=6864432a"
import script from "./OnboardingPage.vue?vue&type=script&lang=js"
export * from "./OnboardingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__